import React from 'react';
import { Container } from 'react-bootstrap';
import clsx from 'clsx';

export interface FooterProps {
  className?: string;
  logo?: string;
  description?: string;
  links?: Array<{
    title: string;
    items: Array<{
      label: string;
      href: string;
      external?: boolean;
    }>;
  }>;
  socialLinks?: Array<{
    icon: string;
    href: string;
    label: string;
    img: string;
  }>;
  copyright?: string;
}

const Footer: React.FC<FooterProps> = ({
  className,
  logo = 'LPDP',
  description = 'Empowering talent development and innovation through cutting-edge solutions.',
  links = [
    {
      title: 'Product',
      items: [
        { label: 'Features', href: '#features' },
        { label: 'Pricing', href: '#pricing' },
        { label: 'Documentation', href: '#docs' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', href: '#about' },
        { label: 'Careers', href: '#careers' },
        { label: 'Contact', href: '#contact' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Help Center', href: '#help' },
        { label: 'Community', href: '#community' },
        { label: 'Status', href: '#status' },
      ]
    }
  ],
  socialLinks = [
    { href: 'https://www.facebook.com/LPDPKemenkeu', label: 'Facebook', img: require('../../../../assets/img/social-media/Facebook.png') },
    { href: 'https://x.com/LPDP_RI/', label: 'Twitter', img: require('../../../../assets/img/social-media/Twitter.png') },
    { href: 'https://www.linkedin.com/company/lembaga-pengelola-dana-pendidikan//', label: 'LinkedIn', img: require('../../../../assets/img/social-media/LinkedIn.png') },
    { href: 'https://www.instagram.com/lpdp_ri/', label: 'Instagram', img: require('../../../../assets/img/social-media/Instagram.png') },
  ],
  copyright = `© ${new Date().getFullYear()} ${logo}. All rights reserved.`
}) => {
  return (
    <footer className={clsx('footer bg-white text-dark border-top border-secondary', className)}>
      {/* <Container className="py-5">
        <Row className="g-4">
          <Col lg={4} md={6}>
            <h5 className="fw-bold mb-3">{logo}</h5>
            <p className="text-muted mb-4">{description}</p>
            <div className="d-flex gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="text-muted text-decoration-none"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} fs-5`}></i>
                </a>
              ))}
            </div>
          </Col>
          
          {links.map((linkGroup, index) => (
            <Col lg={2} md={6} key={index}>
              <h6 className="fw-bold mb-3">{linkGroup.title}</h6>
              <ul className="list-unstyled">
                {linkGroup.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="mb-2">
                    <a
                      href={item.href}
                      className="text-muted text-decoration-none"
                      target={item.external ? '_blank' : undefined}
                      rel={item.external ? 'noopener noreferrer' : undefined}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
          ))}
        </Row>
      </Container> */}

      <Container className='py-5'>
        <div className="row flex-column flex-md-row">
          <div className="col text-center text-md-start align-self-center text-muted mb-3 mb-md-0">
              <p className='m-0'>{copyright}</p>
          </div>
          <div className="col text-center text-md-end">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                className="text-muted text-decoration-none ms-3"
                aria-label={social.label}
              >
                <img width={24} src={social.img} alt={social.label} />
              </a>
            ))}
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;